import { computed, inject, Injectable, Signal, signal } from '@angular/core';
import { PermisoMantisEnum } from '@shared/enums/mantis/permisos-mantis.enum';
import { PerfilMantisEnum } from '@shared/enums/mantis/perfil-mantis.enum';
import { PerfilPermisosMap } from '@shared/constants/mantis/perfil-permisos.map';
import { EstadoMantisEnum } from '../enums/estado-mantis.enum';
import { LocalStorageService } from '@core/services/storage/local.storage.service';

@Injectable({
    providedIn: 'root'
})
export class MantisPermisosService {
    private readonly PERFIL_KEY = 'perfil_usuario';
    //REQUERIMIENTO PLUS - 0061 H3-H4-INICIO
    private _storageService = inject(LocalStorageService);
    //REQUERIMIENTO PLUS - 0061 H3-H4-FIN

    private perfilActual = signal<PerfilMantisEnum | null>(null);

    private _puedeModificar: boolean = false;

     //REQUERIMIENTO PLUS - 0061 H3-H4-INICIO
    setPerfil(perfil: PerfilMantisEnum): void {
        this._storageService.setItem(this.PERFIL_KEY, perfil);
        this.perfilActual.set(this._storageService.getItem<PerfilMantisEnum>(this.PERFIL_KEY))

    }

    getPerfil(): PerfilMantisEnum | null {
        const perfil = this.perfilActual();
        if (perfil != null) {
            return perfil;
        }
        const stored = this._storageService.getItem<PerfilMantisEnum>(this.PERFIL_KEY);
        if (stored != null) {
            this.perfilActual.set(stored);
        }
        return stored;
    }
    //REQUERIMIENTO PLUS - 0061 H3-H4-FIN

    get permisos(): Signal<PermisoMantisEnum[]> {
        return computed(() => {
            const perfil = this.perfilActual();
            return perfil != null ? PerfilPermisosMap[perfil] : [];
        });
    }

    verificarPermiso(permiso: PermisoMantisEnum, siPuedeModificar: boolean = false): boolean {
        const puedeMod = siPuedeModificar === false ? true : this._puedeModificar;
        return this.permisos().includes(permiso) && puedeMod;
    }

    puedeModificarIncidenteActual(estadoActual: string): boolean {
        this._puedeModificar = this.getPerfil() === PerfilMantisEnum.DESARROLLADOR ? ![EstadoMantisEnum.RESUELTA.toString(), EstadoMantisEnum.CERRADA.toString()].includes(estadoActual) : true;
        return this._puedeModificar;
    }

}
